import { Button } from '@nextui-org/react-latest'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

type Props = {}

const SafeContent = ({}: Props) => {
  const { t } = useTranslation('homeLanding/safecontent')
  return (
    <div className="w-full max-w-6xl mx-auto px-4 pt-14 pb-20 text-white">
      <div className="bg-gradient-to-br sm:mx-0 from-[#FCF1FF] to-[#E4E7FF] rounded-3xl mx-auto px-8 py-[99px] text-center">
        <h2 className="text-4xl sm:text-5xl md:text-[64px] font-bold text-uguPurple mb-6">
          {t('title')}
        </h2>

        <p className="text-xl sm:text-2xl text-uguPurple mb-8 max-w-181.25 text-center mx-auto! my-4!">
          {t('description')}
        </p>

        <Button
          radius="full"
          className="px-8 py-4"
          size="lg"
          color="primary"
          as={Link}
          href="/help-centre/legal/privacy-policy"
        >
          {t('button')}
        </Button>
      </div>
    </div>
  )
}

export default SafeContent
